import React from "react";
import { url } from "../../Functionalities/Config";
import image from "../../Assets/images/profile_icon.jpg";
import { ManageReviewDelete } from "./Logic";
import { showMessage } from "../../Functionalities/Functions";
// import confirmAlert from "../../CoreComponents/ConfirmAlert";
// import confirmAlert from "../../CoreComponents/ConfirmAlert";
// import 'react-confirm-alert/src/react-confirm-alert.css'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css

function CommentListingComponent({ review }) {
  // void 0


  // const rateditems = [];

  // const rate = review.rating ? review.rating[0].rating.toFixed(0) : 0;
  // for (let i = 0; i < rate; i++) {
  //   rateditems.push(<i className="fa fa-star text-primary" />);
  // }

  const rateditems = [];
  const rate = review.rating && review.rating.length > 0 && review.rating[0].rating.toFixed(0);
  for (let i = 0; i < rate; i++) {
    rateditems.push(<i className="fa fa-star text-primary" />);
  }


  // const notrateditems = [];
  // for (let i = 0; i < 5 - rate; i++) {
  //   notrateditems.push(<i className="fa fa-star text-gray" />);
  // }

  return (
    <div className="media review-box">
      {review.voter.images != null ? (
        <img
          className="mr-3 img-fluid btn-rounded"
          width={55}
          height={55}
          src={url + review.voter.images.image}
          alt="Foodoor"
        />
      ) : (
        <img
          className="mr-3 img-fluid btn-rounded"
          width={55}
          height={55}
          src={image}
          alt="Foodoor"
        />
      )}
      <div className="media-body">
        <div className="row">
          <a href={`/customerID/${review.voter.id}`}><h4 className="mt-0 mb-0 text-black">{review.voter.first_name}</h4></a>
          <li role="presentation" className="ml-2">
            <i className="fa fa-trash-o text-danger" style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.preventDefault();

                confirmAlert({
                  customUI: ({ onClose }) => {
                    return (
                      <div className='custom-ui' style={{ borderRadius: 8, border: 'solid', padding: 70, borderWidth: 0.5 }}>
                        <h1>Are you sure?</h1>
                        <p>You want to delete ?</p>
                        <button onClick={onClose} className="btn btn-primary" style={{ marginRight: 10, }}>Cancel</button>
                        <button
                          onClick={() => {
                            let result = ManageReviewDelete(e, '', 'delete', `review_id=[{"review_id" : ${review.id}}]`)
                            result.then((result) => {
                              if (result) {

                                showMessage("Delete success", "success", "Success!", "top", "top-right")

                                window.location.replace('/comments')
                              } else {
                                showMessage("delete failed", "danger", "Failed!", "top", "top-right")
                              }
                            }).catch(err => {
                              showMessage("delete failed", "danger", "Error!", "top", "top-right")

                            })
                          }}
                          className="btn btn-primary"
                        > Delete
                </button>
                      </div>
                    );
                  }
                });
              }}


            // onClick={(e) => {
            //   window.confirm(
            //     "Are you sure you want to delete this review"
            //   )
            //     &&
            //     ManageReviewDelete(e, '', 'delete', `review_id=[{"review_id" : ${review.id}}]`)
            //       .then((res) => { void 0 })
            //       .catch((err) => { void 0 }) && window.location.reload();
            // }
            // }
            ></i>
            <a href="#for" role="tab" data-toggle="tab">
              <img className="img-fluid"
                // src={item.image} 
                alt width={50} />
            </a>
          </li>

        </div>


        <ul className="review-meta mb-3 d-block d-sm-flex align-items-center">
          <li className="mr-3">
            <small>{new Date(review.review_time).toDateString()}</small>
          </li>
          <li className="mr-3">
            <small>Restaurant : {review.branch_name}</small>
          </li>
          <li className="mr-3">
            <small>Product : {review.item_name}</small>
          </li>
        </ul>

        <p className="mb-3 text-secondary">{review.review}</p>
      </div>
      <div className="media-footer align-self-center">

        <div className="star-review text-md-center">
          {/* <span className="text-secondary">{rate}</span> */}
          {/* {rateditems}
          {notrateditems} */}
          {typeof review.rating != "undefined" &&
            review.rating != null &&
            review.rating.length != null &&
            review.rating.length > 0 ? (
            <div class="star-review2 d-flex align-items-center flex-wrap fs-12 mt-2 ml-5">
              <div class="mb-4">
                <i class="fa fa-star text-primary">
                  &nbsp;
                  {review.rating[0].rating.toFixed(1)}
                </i>
              </div>
            </div>
          ) : (
            <div class="star-review2 d-flex align-items-center flex-wrap fs-12 mt-2 ml-5">
              <div class="mb-4">
                <i class="fa fa-star text-primary">&nbsp; 0</i>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CommentListingComponent;
